import { createComponent } from '@carvana/merch-components';
import classNames from 'classnames';
import React, { forwardRef } from 'react';

export type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & {
  disabled?: boolean;
  isFavorited?: boolean;
};

const HeartWithBorderThin = createComponent<OwnProps>('svg', {
  className: 'u:text-blue-7'
});

export default forwardRef<SVGSVGElement, OwnProps>(
  ({ disabled, isFavorited, ...props }, ref) => (
    <HeartWithBorderThin
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      ref={ref}
      {...props}
    >
      <path
        className={classNames('fill-none', {
          'stroke-grey-3': disabled,
          'fill-red-2 stroke-red-2': isFavorited
        })}
        d="M4.42871 5.44197L4.42886 5.44182C5.35213 4.50865 6.57103 4 7.87406 4C9.16314 4 10.3748 4.50063 11.2925 5.41689L11.998 6.12138L12.7046 5.41792C14.6085 3.52241 17.6799 3.52997 19.5703 5.44067L19.5705 5.44084C21.4731 7.36311 21.4764 10.4934 19.581 12.4188L11.9929 19.6208L4.41869 12.4215C2.52347 10.4936 2.52741 7.36284 4.42871 5.44197Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </HeartWithBorderThin>
  )
);
